import { useEffect, useRef, useState } from "react";
import { Paper, Box, CircularProgress } from "@mui/material";
import theme from "../../../styles/Themecolors";

const useInfiniteScroll = (fetchData, row, setRow) => {
   
   const isFetchingRef = useRef(false);
   const [isLoading, setIsLoading] = useState(false); // State for loading indicator
   
  //  const handleScroll = (event) => {
  //    const listboxNode = event.target;
  //    const isBottom =
  //      listboxNode.scrollHeight - listboxNode.scrollTop <=
  //      listboxNode.clientHeight + 10;
   
  //    if (isBottom && !isFetchingRef.current) {
  //      isFetchingRef.current = true;
  //     //  setIsLoading(true); // Show loading when fetching
  //      setRow((prev) => prev + 20);
  //    }
  //  };
   
  //  useEffect(() => {
  //    fetchData("", row, 20).then(() => {
  //      isFetchingRef.current = false;
  //     //  setIsLoading(false); // Hide loading once rows is fetched
  //    });
  //  }, [row]);
  const handleScroll = (event) => {
    const listboxNode = event.target;
    const isBottom =
      listboxNode.scrollHeight - listboxNode.scrollTop <=
      listboxNode.clientHeight + 10;
  
    if (isBottom && !isFetchingRef.current) {
      isFetchingRef.current = true;
  
      setRow((prev) => {
        const newRow = prev + 20;
        
        // Call fetchData with the updated value
        fetchData("", newRow, 20).then(() => {
          isFetchingRef.current = false;
        });
  
        return newRow;
      });
    }
  };
  
  const ListboxProps = {
    onScroll:isLoading===false && handleScroll,
    sx: {
      maxHeight: "400px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: `${theme.palette.primary.main} ${theme.palette.background.default}`, // Firefox
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: theme.palette.background.default,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.primary.main,
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  };

  const PaperComponent = ({ children, ...props }) => (
    // <Paper {...props} sx={{ maxHeight: "400px", overflowY: "auto" }}>
    //   {children}
    //   {isLoading===true && (
    //     <Box  sx={{
    //       position: "sticky",
    //       bottom: 0,
    //       left: 0,
    //       right: 0,
    //       display: "flex",
    //       justifyContent: "center",
    //       backgroundColor: theme.palette.background.default,
    //       p: 1,
    //       zIndex: 2,
    //     }}>
    //       <CircularProgress size={20} />
    //     </Box>
    //   )}
    // </Paper>
     <Paper
    {...props}
    sx={{
      maxWidth: '455px',
      width: 'fit-content', // grows with content
      minWidth: '100%',     // match input width
      overflowX: 'auto',    // prevent content cut-off
    }}
  >
    {children}
  </Paper>
  );

  return { setIsLoading, ListboxProps,
    
    
    PaperComponent
   };
};

export default useInfiniteScroll;
